import React, { useState } from 'react';
import StatusDropdown from '../StatusDropdown';
import EmployeeOverviewStatusCard from './EmployeeOverviewStatusCard';
import {ReactComponent as CopyIcon} from '../../components/svgs/copyIcon.svg'
import {ReactComponent as QrcodeIcon} from '../../components/svgs/qrcodeIcon.svg'
import {ReactComponent as HumanIcon} from '../../components/svgs/humanIcon.svg'
import {ReactComponent as MessageIcon} from '../../components/svgs/messageIcon.svg'
import {ReactComponent as PhoneIcon} from '../../components/svgs/phoneIcon.svg'
import {ReactComponent as DateIcon} from '../../components/svgs/dateIcon.svg'
import {ReactComponent as UserIdentifierIcon} from '../../components/svgs/userIdentifier.svg'
import EmployeeOrderTab from './EmployeeOrderTab';




// laundry status data
const laundryStatus = [
    { label: 'All', link: '#' },
    { label: 'Binned', link: '#' },
    { label: 'Washing', link: '#' },
    { label: 'Drying', link: '#' },
    { label: 'Folding', link: '#' },
  ];
  

const EmployeesDetailsTab = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="">
      <div className={`tab ${activeTab === 'overview' ? 'active' : ''}`} onClick={() => handleTabClick('overview')}>
        Overview
      </div>
      <div className={`tab ${activeTab === 'activity' ? 'active' : ''}`} onClick={() => handleTabClick('activity')}>
        Activity
      </div>
      <div className={`tab ${activeTab === 'ordersManaged' ? 'active' : ''}`} onClick={() => handleTabClick('ordersManaged')}>
        Orders Managed
      </div>
    <div className='order-details-tab-divider'></div>
      <div className="tab-content">
        {activeTab === 'overview' && (
        <div className="details-content">
            <section className='flex '>
                <section className='flex flex-col order-details-section-container employee-details-section-container'>
                    <section className='flex gap-6'>
                        <EmployeeOverviewStatusCard cardNumber={23} noOfOrdersClassName="custom-style" cardTitle={'Orders recorded'} cardSubtitle={'orders'} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="ml-28" />}/>
                        <EmployeeOverviewStatusCard cardNumber={'$ 1,600.00'} noOfOrdersClassName="custom-style" cardTitle={'Revenue'} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="ml-48" />}/>
                    </section>
                    
                    <EmployeeOverviewStatusCard cardNumber={'$ 138.33'} noOfOrdersClassName="custom-style" cardTitle={'Tips'} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="ml-60" />}/>
                </section>
                <section className='flex customer-details-section-container'>
                    <div className='flex gap-10'>
                        <QrcodeIcon />
                        <div className='flex flex-col gap-3'>
                            <p className='overview-title'>Customer ID</p>
                            <p className='overview-subtitle'>CUS_i2khfmvg3bz7q5r</p>
                        </div>
                        <div className='copy-icon'>
                        <CopyIcon/>
                        </div>
                        
                    </div>
                    <div className='flex gap-10 '>
                        <HumanIcon />
                        <div className='flex flex-col gap-3'>
                            <p className='overview-title'>First Name</p>
                            <p className='overview-subtitle'>Phoebe</p>
                        </div>
                        <div className='copy-icon-2'>
                        <CopyIcon/>
                        </div>
                    </div>
                    <div className='flex gap-10'>
                        <HumanIcon />
                        <div className='flex flex-col gap-3'>
                            <p className='overview-title'>Last Name</p>
                            <p className='overview-subtitle'>Buffay</p>
                        </div>
                        <div className='copy-icon-2'>
                        <CopyIcon/>
                        </div>
                    </div>
                    <div className='flex gap-10'>
                        <UserIdentifierIcon />
                        <div className='flex flex-col gap-3'>
                            <p className='overview-title'>Role(s)</p>
                            <div className='overview-subtitle flex gap-4'>
                                <div className='role-border-container attendant-border'><p>Attendant</p></div>
                                <div className='manager-border role-border-container'><p>Manager</p></div>
                                <div className='owner-border role-border-container'><p>Owner</p></div>
                            </div>
                        </div>
                        
                    </div>
                    <div className='flex gap-10'>
                        <PhoneIcon />
                        <div className='flex flex-col gap-3'>
                            <p className='overview-title'>Phone Number</p>
                            <p className='overview-subtitle'>+123456789</p>
                        </div>
                        <div className='copy-icon-3'>
                        <CopyIcon/>
                        </div>
                    </div>
                    <div className='flex gap-10'>
                        <MessageIcon />
                        <div className='flex flex-col gap-3'>
                            <p className='overview-title'>Emails</p>
                            <p className='overview-subtitle'>phoebe.b@mail.com</p>
                        </div>
                        <div className='copy-icon-4'>
                        <CopyIcon/>
                        </div>
                    </div>
                    <div className='flex gap-10'>
                        <DateIcon />
                        <div className='flex flex-col gap-3'>
                            <p className='overview-title'>Date Created</p>
                            <p className='overview-subtitle'>Friday, Sep 25, 2023</p>
                        </div>
                        
                    </div>


                </section>
            </section>
            
            
        </div>
          
        )}

        {activeTab === 'activity' && (
          <div className="activity-content employee-activity-container">
            {/* Activity log layout */}
            <section>
                <div>
                    <div className='activity-log-day-bg employee-activity-log'>
                        <p className='activity-log-day-text'>Today</p>
                    </div>
                    <div className='activity-log-content-bg'>
                        <p className='activity-log-time-text'>07/11/23 <span className='activity-log-day-details ml-4'>Angela set status to washing </span></p>
                        
                    </div>
                    <div className='activity-log-content-bg'>
                        <p className='activity-log-time-text'>07/11/23 <span className='activity-log-day-details ml-4'>Angela set status to washing </span></p>
                        
                    </div>
                    <div className='activity-log-content-bg'>
                        <p className='activity-log-time-text'>07/11/23 <span className='activity-log-day-details ml-4'>Angela set status to washing </span></p>
                        
                    </div>                    
                </div>
                <div>
                    <div className='activity-log-day-bg'>
                        <p className='activity-log-day-text'>Today</p>
                    </div>
                    <div className='activity-log-content-bg'>
                        <p className='activity-log-day-text'>07/11/23 <span className='activity-log-day-details ml-4'>Angela set status to washing </span></p>
                        
                    </div>                    
                </div>
            </section>
            

          </div>
        )}

        {activeTab === 'ordersManaged' && (
                <EmployeeOrderTab />
                )}

      </div>
    </div>
  );
};

export default EmployeesDetailsTab;
